"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _constants = require("./constants");

var _ref;

var _default = new _immutable.Record((_ref = {
  appId: null
}, (0, _defineProperty2.default)(_ref, _constants.CAMPAIGN_NAME, null), (0, _defineProperty2.default)(_ref, _constants.CREATE_CONTACT, null), (0, _defineProperty2.default)(_ref, _constants.CREATED_AT, null), (0, _defineProperty2.default)(_ref, _constants.CREATED_BY, null), (0, _defineProperty2.default)(_ref, "deleted", null), (0, _defineProperty2.default)(_ref, "emailCampaignId", null), (0, _defineProperty2.default)(_ref, _constants.PASSWORD, null), (0, _defineProperty2.default)(_ref, "passwordHash", null), (0, _defineProperty2.default)(_ref, "portalId", null), (0, _defineProperty2.default)(_ref, _constants.USER_NAME, null), _ref), _constants.SMTP_TOKEN);

exports.default = _default;
module.exports = exports.default;